import { render } from "./NewGroupChatComponent.vue?vue&type=template&id=74b79c16&scoped=true&ts=true"
import script from "./NewGroupChatComponent.vue?vue&type=script&lang=ts"
export * from "./NewGroupChatComponent.vue?vue&type=script&lang=ts"

import "./NewGroupChatComponent.vue?vue&type=style&index=0&id=74b79c16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b79c16"]])

export default __exports__